<template>
  <div>
    <div class="mb-4">
      <label>Название</label>
      <va-input v-model="tileTitle" placeholder="Введите название" />
    </div>
    <div class="mb-4">
      <label>Ссылка</label>
      <va-input v-model="tileLink" placeholder="/catalog/category" />
    </div>
    <div class="upload-block mb-4">
      <label for="tile-img" class="upload-label">Загрузить фото</label>
      <input
        id="tile-img"
        class="upload-img-input"
        accept="image/x-png,image/jpg,image/jpeg"
        type="file"
        @change="onFilePicked"
      />
    </div>
    <div v-if="imageData !== ''" class="mb-4">
      <img :src="imageData" alt="" />
    </div>
    <div class="mb-4">
      <label>Цвет фона</label>
      <input v-model="tileBgColor" type="color" />
      <va-input v-model="tileBgColor" placeholder="#D8E0EB" />
    </div>
    <div class="mb-4">
      <label>Порядок</label>
      <va-input v-model.number="tileOrder" type="number" placeholder="0" />
    </div>
    <div class="mb-4">
      <label>Статус</label>
      <va-checkbox v-model="tileActive" />
      <span>{{ tileActive ? "Включен" : "Выключен" }}</span>
    </div>
    <div class="mt-4 text-center">
      <va-button color="primary" type="button" @click="$emit('action', true)">
        Отменить
      </va-button>

      <va-button color="success" type="submit" @click="submit">
        Сохранить
      </va-button>
    </div>
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      file: "",
      imageData: "",
      tileTitle: "",
      tileLink: "",
      tileBgColor: "#D8E0EB",
      tileOrder: 0,
      tileActive: true,
    };
  },
  methods: {
    ...mapActions({
      fetchCategoryTiles: "categoryTiles/getCategoryTiles",
    }),
    onFilePicked(event) {
      if (event.target.files && event.target.files[0]) {
        this.file = event.target.files[0];
        const imgUrl = URL.createObjectURL(this.file);
        this.imageData = imgUrl;
      }
    },
    async submit() {
      try {
        const formData = new FormData();
        formData.append("file", this.file, this.file.name);
        const fileInfo = await api.post("/upload-file", formData);
        const data = {
          title: this.tileTitle,
          link: this.tileLink,
          bg_color: this.tileBgColor,
          photo_id: fileInfo.data.id,
          order: this.tileOrder,
          active: this.tileActive,
        };
        await api.post("/admin/category-tiles", data);
        await this.fetchCategoryTiles();
        this.$emit("action", true);
      } catch (error) {
        return error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}
.upload-block {
  position: relative;
}
.upload-img-input {
  appearance: none;
  visibility: hidden;
}
.upload-label {
  padding: 0.375rem 1.25rem;
  background-color: rgb(44, 130, 224);
  color: #fff;
  font-weight: bold;
  border-radius: 1.5rem;
  cursor: pointer;
  display: inline-block;
}
</style>
